(() => {
  if (customElements.get('amk-catalog')) return;
  customElements.define('amk-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick, true);
      let layout = this.dataset.defaultLayout;
      try { layout = localStorage.getItem('amk-catalog-layout') || layout; } catch (_) { /* Storage may be disabled. */ }
      this.setLayout(layout);
      this.countObserver = new MutationObserver(() => this.syncCount());
      const count = this.querySelector('#ProductCount');
      if (count) this.countObserver.observe(count, {childList:true,subtree:true,characterData:true});
      this.syncCount();
    }
    setLayout(layout) {
      this.dataset.layout = layout === 'list' ? 'list' : 'grid';
      this.querySelectorAll('[data-amk-layout]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.amkLayout === this.dataset.layout)));
    }
    syncCount() {
      const source = this.querySelector('#ProductCount');
      const target = this.querySelector('[data-amk-catalog-count]');
      const text = source?.textContent.trim();
      if (target && text && target.textContent !== text) target.textContent = text;
    }
    handleClick(event) {
      const apply = event.target.closest('.mobile-facets__footer button.button--primary');
      if (apply && this.contains(apply)) {
        const close = apply.closest('.mobile-facets__wrapper')?.querySelector('.mobile-facets__close');
        if (close) {
          event.preventDefault();
          event.stopImmediatePropagation();
          close.click();
        }
        return;
      }
      const view = event.target.closest('[data-amk-layout]');
      if (view && this.contains(view)) {
        this.setLayout(view.dataset.amkLayout);
        try { localStorage.setItem('amk-catalog-layout', this.dataset.layout); } catch (_) { /* Keep the in-page choice. */ }
        return;
      }
      const button = event.target.closest('[data-amk-quantity]');
      if (!button || button.disabled || !this.contains(button)) return;
      const input = button.parentElement.querySelector('input');
      const direction = Number(button.dataset.amkQuantity);
      const min = Number(input.min) || 1;
      const value = Number(input.value);
      if (!Number.isFinite(value) || !input.validity.valid) input.value = String(min);
      else {
        try { if (direction > 0) input.stepUp(); else input.stepDown(); } catch (_) { input.value = String(min); }
      }
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick, true);
      this.countObserver?.disconnect();
      this.ready = false;
    }
  });
})();
